export default function getAppCountry() {
	const hostname = window.location.hostname;

	// Split the hostname by dots
	const parts = hostname.split(".");
	// Return the last part as the domain extension
	const domainExtension = parts[parts.length - 1];

  return domainExtension.toUpperCase() === "LOCALHOST"
	  ? "DE"
	  : domainExtension.toUpperCase();
}
